import { unescape } from 'lodash';

/**
 * The user JSON blob that Edge injects into the page (`window.coursera.user`,
 * read via `clientSideUserJson`, and the SSR request-namespace `userJson`) is
 * produced by a legacy server template that HTML-entity-encodes string values
 * (e.g. `&` -> `&amp;`, `<` -> `&lt;`). That blob is consumed as plain JS strings
 * which React re-escapes on render, so the entities must be decoded on read —
 * otherwise a name like "Learning & Development" renders literally as
 * "Learning &amp; Development" (LO-4491).
 *
 * Centralised here because the escaped blob is read in several places
 * (`js/lib/user`, `js/lib/user.server`, `ApplicationStore.getUserData`).
 *
 * Safe against XSS: every consumer renders the name as React text, not raw HTML.
 */
export const decodeUserName = <T extends string | null | undefined>(name: T): T =>
  typeof name === 'string' ? (unescape(name) as T) : name;

export default decodeUserName;
